<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']"
  titleText="i18n.domain.parking-card.title"></app-title-bar>
<div class="row">
  <div class="col-4">
    <div class='d-lg-flex align-items-center mb-3 e-btn-group'>
      <input type="radio" id="issuedbyMe" name="assignment" [value]="false" [(ngModel)]="issuedToMe"
        (change)="changeView()" />
      <label class="e-btn p-0" for="issuedbyMe">{{ 'i18n.domain.parking-card.issued-by-me-label' | translate}}</label>
      <input type="radio" id="issuedToMe" name="assignment" [value]="true" [(ngModel)]="issuedToMe"
        (change)="changeView()" />
      <label class="e-btn p-0" for="issuedToMe">{{ 'i18n.domain.parking-card.issued-to-me-label' | translate}}</label>
    </div>
  </div>
</div>

<div class="control-section">
  <ejs-grid #grid class="grid-with-footer" width="100%" rowHeight="38" [dataSource]="data" [allowSorting]="true"
    [filterSettings]="filterSettings" [allowFiltering]="true" [allowPaging]="true" [pageSettings]="pageSettings"
    [searchSettings]="searchOptions" (actionComplete)="actionComplete($event)" (actionBegin)="actionBegin($event)"
    (rowDataBound)="rowDataBound($event)" (commandClick)="commandClick($event)">
    <e-columns>
      <e-column field="id" [visible]="false" headerText="id" [isPrimaryKey]="true"></e-column>
      <e-column *ngIf="issuedToMe" field="visitorAlias" type="string" headerText="{{'i18n.domain.parking-card.grid.name' | translate}}"
        clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column *ngIf="!issuedToMe" field="parkerAlias" type="string" headerText="{{'i18n.domain.parking-card.grid.name' | translate}}"
        clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column *ngIf="issuedToMe" field="issuingParkerName" type="string"
        headerText="{{'i18n.domain.parking-card.grid.issuing-parker' | translate}}" clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column *ngIf="!issuedToMe" field="issuedToUserName" type="string"
        headerText="{{'i18n.domain.parking-card.grid.issued-to' | translate}}" clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="controlPlateNumber" type="string"
        headerText="{{'i18n.domain.parking-card.grid.control-plate' | translate}}" clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="validFromDateTime" headerText="{{'i18n.domain.parking-card.grid.valid-from' | translate}}"
        width="140px" type="date" [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.validFromDateTime | date:'dd.MM.yyyy'}}
        </ng-template>
      </e-column>
      <e-column field="validToDateTime" headerText="{{'i18n.domain.parking-card.grid.valid-to' | translate}}"
        width="140px" type="date" [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.validToDateTime | date:'dd.MM.yyyy'}}
        </ng-template>
      </e-column>
      <e-column field="forMultipleUse" headerText="{{'i18n.domain.parking-card.grid.multiple-use' | translate}}"
        width="160px" [defaultValue]="true" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'forMultipleUse')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data?.forMultipleUse"></span>
        </ng-template>
      </e-column>
      <e-column field="lastUsedOn" headerText="{{'i18n.domain.parking-card.grid.last-used-on' | translate}}" type="date"
        [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.lastUsedOn | date:'dd.MM.yyyy HH:mm:ss'}}
        </ng-template>
      </e-column>
      <e-column field="clientName" type="string"
        headerText="{{'i18n.domain.parking-card.grid.client-name' | translate}}" clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="isActive" headerText="{{'i18n.shared.fields.active' | translate}}" width="120px"
        [defaultValue]="true" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'isActive')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isActive"></span>
        </ng-template>
      </e-column>
      <e-column headerText="" *ngIf="!issuedToMe" [commands]="gridCommands" width="40px"></e-column>
    </e-columns>
  </ejs-grid>
</div>